import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GenericDropDownV3, TS_MultiSelect_V2 } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_User } from './ModuleFE_User.js';
import { DBItemDropDownMultiSelector } from '@nu-art/thunderstorm-frontend/components/_TS_MultiSelect/DBItemDropDownMultiSelector';
import { ICONS } from '@app/styles';
import { composeUserDisplay } from './utils.js';
const Props_DropDown = {
    module: ModuleFE_User,
    modules: [ModuleFE_User],
    mapper: item => [composeUserDisplay(item)],
    placeholder: 'Choose a User',
    renderer: item => _jsx(_Fragment, { children: composeUserDisplay(item) }),
};
export const DropDown_User = GenericDropDownV3.prepare(Props_DropDown);
const Props_MultiSelect = DBItemDropDownMultiSelector.propsV3({
    module: ModuleFE_User,
    itemRenderer: (item, onDelete) => {
        return !item ? _jsx(_Fragment, { children: "Not Found" }) : _jsxs(_Fragment, { children: [_jsx(ICONS.x.component, { onClick: onDelete }), composeUserDisplay(item)] });
    },
    uiSelector: DropDown_User.selectable,
});
export const MultiSelect_User = TS_MultiSelect_V2.prepare(Props_MultiSelect);
//# sourceMappingURL=ui-components.js.map